/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'embedded-confluence.modal.close-button': 'Close',
  'embedded-confluence.modal.contract-button': 'Contract',
  'embedded-confluence.modal.open-in-confluence': 'Open In Confluence',
  'embedded-confluence.panel.close-button': 'Close',
  'embedded-confluence.panel.expand-button': 'Expand',
  'embedded-confluence.panel.open-in-confluence': 'Open In Confluence',
};
